/**
 * 查看路径信息
 * @author wql
 * @date 2020-8-23
 */
import React from 'react';
import { connect } from 'dva';
import '@/styles/containers/train/path/trainPathStage/style.less'

import { framework_tool, component_tool, utils_tool } from '@/tool';
import { modelUtils } from '@/utils';
import createColumns from "./historyColumns";
import {WizModalUserIdentityShow} from '../../../../containers/common';
import TrainPathInfo from './components/trainPathInfo';

const { WizContainer,ossFileUtils} = framework_tool
const { Session,getPageData} = utils_tool;
const {WizButton, WizRow, WizCol,WizTable,WizCard,WizSpin,WizCollapse,WizTabs,WizModal,WizSearchBar,WizDataTable} = component_tool;

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location && history.location.record) {
      record = history.location.record;
      Session.set('trainPathInfo', record)
    } else {
      record = Session.get('trainPathInfo') || 0
    }
  } else {
    record = Session.get('trainPathInfo') || 0
  }
  return record
}

// const getFile = (fileId, fileName, fileMimeType, fileSize, fileUri) => {
//   return ossFileUtils.getOssFile(
//     fileId, fileName, fileMimeType, fileSize, fileUri,
//   );
// }

class LookTrainPath extends WizContainer {

    componentName = 'lookTrainPath';

  constructor(props) {
    super(props);
    let pathname = '/trainPath'
    if (history.location && history.location.pathname && history.location.pathname.startsWith('/perm/trainPathPerm')) {
      pathname = '/perm/trainPathPerm'
    }
    this.pathname = pathname
    this.state = {
      getPathInfo: [],
      getStudentPathList:[],
      getStudentInfo:[],
      visible:false,
      modelName:'',
      showUserPersonInfoVisible: false,
      personId: '',
    }
    this.initialValue = getParamRecord(props.history);
    // let file = getFile(this.initialValue.fileId, this.initialValue.fileName, this.initialValue.fileMimeType, this.initialValue.fileSize, this.initialValue.fileUri);
    //let fileId = getOssFilePath(this.initialValue.fileId);
    let fileId = this.initialValue.fileId ? getOssFilePath(this.initialValue.fileId) : constants.files.sys_path_default_image;
    this.initialValue.fileUri = fileId;
  }

  propsAndStateOnChange = {
    getPathInfo:this._handleCMD.bind(this),
    getStudentPathList: this._studentPathList.bind(this),
    getStudentPathInfo: this._getStudentPathInfo.bind(this)
  };

  _handleCMD(nextProps, nextState) {
    let o = nextProps.getPathInfo;
    if (o['success']) {
      nextState.getPathInfo = o.data
      return true;
    }

    wizNotice.error(o['msg'])
    return false;
  }

  _studentPathList(nextProps, nextState) {
    let o = nextProps.getStudentPathList;
    if (o['success']) {
      let data = o.data.records;
      nextState.getStudentPathList = o.data.records
      return true;
    }
    wizNotice.error(o['msg'])
    return false;
  }

  _getStudentPathInfo(nextProps, nextState) {
    let o = nextProps.getStudentPathInfo;
    if (o['success']) {
      let data = o.data;
      nextState.getStudentInfo = o.data
      return true;
    }

    wizNotice.error(o['msg'])
    return false;
  }

  _componentDidMount() {
    this._getStageListDate()
    this._getDate()
  }

  _getDate(){
    this.doActions([
      {
        path: 'trainPathStage/getStudentPathList',
        payload: {
          key: 'getStudentPathList',
          apiParams: {trainPathId: this.initialValue.id}
        }
      },
    ]);
  }

  _getStageListDate(){
    this.doActions([
      {
        path: 'trainPathStage/getPathInfo',
        payload: {
          key: 'getPathInfo',
          apiParams: {id: this.initialValue.id}
        }
      },
    ]);
  }

  getPathList(){
    let columns = [
      { title: '任务名称',
        dataIndex: 'name',
        key: 'name'},
      { title: '任务类型',
        dataIndex: 'type',
        key: 'type'},
      { title: '任务内容',
        dataIndex: 'entityName',
        key: 'entityName'},
      { title: '任务学习方式',
        dataIndex: 'learningStyle',
        key: 'learningStyle'},
      { title: '任务状态',
        dataIndex: 'state',
        key: 'state'},
      { title: '添加时间',
        dataIndex: 'createTime',
        key: 'createTime'},
    ]
    let pathList = this.state.getPathInfo;
    let data = [];
    if (pathList.length>0){
      pathList.forEach(info =>{
        if(info.state == 1){
          info.state = '草稿'
        }else if(info.state == 2){
          info.state = '已发布'
        }else if(info.state == 3){
          info.state = '已关闭'
        }else if(info.state == 4){
          info.state = '建设中'
        }
        let header = info.name + '  ' + '[ '+ info.state + ' ]' + '(已参加人数：' + info.joinNum + ')'

        info.taskList.forEach(val =>{
          if (val.type == 1){
            val.type = '在线课程'
          }else if(val.type == 2){
            val.type = '在线考试'
          }else if(val.type == 3){
            val.type = '培训班级'
          }else if(val.type == 4){
            val.type = '能力认证'
          }else if(val.type == 5){
            val.type = '在线评语'
          }else if (val.type == 6) {
            val.type = '课程组'
          }else if(val.type == 7) {
            val.type = '资讯'
          }else if(val.type == 8) {
            val.type = '作业'
          }

          if (val.learningStyle == 0){
            val.learningStyle = '自主学习'
          }else if(val.learningStyle == 1){
            val.learningStyle = '顺序学习'
          }

          if(val.state == 1){
            val.state = '草稿'
          }else if(val.state == 2){
            val.state = '已发布'
          }else if(val.state == 3){
            val.state = '已关闭'
          }
        })
        data.push(
          <WizCollapse className='administrationScope-collapse'
                       expandIconPosition='right'
                       defaultActiveKey={[
                         0
                       ]}
          >
            <WizCollapse.Panel key={info.id} header={<WizButton type="link" onClick={e => this.jump(info.name,info.id)}>{header}</WizButton>} className='panel-item'>
              <WizTable dataSource={info.taskList} columns={columns} />
            </WizCollapse.Panel>
          </WizCollapse>
        )
      })
      return data
    }

    return null
  };

  handleOk = e => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  getStudentPathList(other = {}){
    let param = {};
    if (this.state.apiParams){
      param = {...this.state.apiParams}
    }
    param.trainPathId = this.initialValue.id
    this.doActions([
      {
        path: 'trainPathStage/getStudentPathList',
        payload: {
          key: 'getStudentPathList',
          apiParams: { ...param, ...other }
        }
      },
    ]);
  }

  jump(val,id){
    let initialValue = this.initialValue;
    initialValue.stageName = val
    initialValue.trainPathStageId = id
    this.jumpPage('push', this.pathname+'/studentTrainPathList',initialValue);
  }

  getStudentPathInfo(){
    let columns = [
      { title: '任务名称',
        dataIndex: 'name',
        key: 'name'},
      { title: '任务类型',
        dataIndex: 'type',
        key: 'type'},
      { title: '任务内容',
        dataIndex: 'entityName',
        key: 'entityName'},
      { title: '状态',
        dataIndex: 'taskPassState',
        key: 'taskPassState'},
      { title: '完成时间',
        dataIndex: 'taskPassTime',
        key: 'taskPassTime'},
    ]
    let pathList = this.state.getStudentInfo;
    let data = [];
    if (pathList.length>0){
      pathList.forEach(info =>{
        if(info.state = 1){
          info.state = '草稿'
        }else if(info.state = 2){
          info.state = '已发布'
        }else if(info.state = 3){
          info.state = '已关闭'
        }else if(info.state = 4){
          info.state = '建设中'
        }

        info.taskList.forEach(val =>{
          if (val.type == 1){
            val.type = '在线课程'
          }else if(val.type == 2){
            val.type = '在线考试'
          }else if(val.type == 3){
            val.type = '培训班级'
          }else if(val.type == 4){
            val.type = '能力认证'
          }else if(val.type == 5){
            val.type = '在线评语'
          }else if (val.type == 6) {
            val.type = '课程组'
          }else if(val.type == 7) {
            val.type = '资讯'
          }else if(val.type == 8) {
            val.type = '作业'
          }

          if (val.taskPassState == 1){
            val.taskPassState = '通过';
          }else if (val.taskPassState == 0){
            val.taskPassState = '未通过';
          }
          if(val.type == '作业' && val.taskPassState == '未通过'){
            val.taskPassTime=""
          }

        })

        let header = info.name + '(' + info.proportion + ')'
        data.push(
          <WizCollapse className='administrationScope-collapse'
                       expandIconPosition='right'
                       defaultActiveKey={[
                         0
                       ]}
          >
            <WizCollapse.Panel key={info.id} header={header} className='panel-item'>
              <WizTable dataSource={info.taskList} columns={columns} />;
            </WizCollapse.Panel>
          </WizCollapse>
        )
      })
      return data
    }else{
      return null
    }
  };


  openModel(val){
    this.doActions([
      {
        path: 'trainPathStage/getStudentPathInfo',
        payload: {
          key: 'getStudentPathInfo',
          apiParams: {
            id: this.initialValue.id,
            personId:val.personId
          }
        }
      },
    ]);
    this.setState({
      modelName: this.initialValue.name + '-' + val.fullName,
      visible: true,
    });
  }


  getStudyHistory(){
    const columns = [
      {
        title: '账号',
        dataIndex: 'account',
        key: 'account',
      },
      {
        title: '姓名',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '证件号码',
        dataIndex: 'idCard',
        key: 'idCard',
      },
      {
        title: '手机号',
        dataIndex: 'mobile',
        key: 'mobile',
      },
      {
        title: '账号状态',
        dataIndex: 'accountState',
        key: 'accountState',
      },
      {
        title: '最高等级',
        dataIndex: 'stageComplete',
        key: 'stageComplete',
      },
      {
        title: '最近学习时间',
        dataIndex: 'newDate',
        key: 'newDate',
      },
      {
        title: '操作',
        key: 'action',
        render: (text, record) => (
          <div>
            <WizButton type="link" onClick={e => this.openModel(record)}>查看学员路径</WizButton>
            <WizButton type="link" >查看任职</WizButton>
          </div>
        ),
      }
    ];

    return(
      <WizTable dataSource={this.state.getStudentPathList} columns={columns} />
    )
  }

  _onSubmit(val){
    let account = val.account != undefined &&  val.account != null ? val.account : '';
    let name = val.name != undefined &&  val.name != null ? val.name : '';

    let param = {trainPathId:this.initialValue.id};
    if (account != ''){
      param.account = account;
    }
    if (name != ''){
      param.name = name;
    }

    this.doActions([
      {
        path: 'trainPathStage/getStudentPathList',
        payload: {
          key: 'getStudentPathList',
          apiParams: param
        }
      },
    ]);
  }

  _onReset() {
    this.refs.form && this.refs.form.resetFields && this.refs.form.resetFields()
  }

  _onManagement(record){
    this._showUserPersonModal(record.personId);
  }

  _showUserPersonModal = (personId) => {
    this.setState({
      personId : personId,
      showUserPersonInfoVisible: true,
    })
  };

  formFooter = () => {
    return (
      <WizRow className="form-btns row-item">
        <WizCol span={20}></WizCol>
        <WizCol span={4}>
          <WizButton title='查询' htmlType='submit' type='primary' htmlType='submit'>查询</WizButton>
          <WizButton title='重置' type='reset' onClick={e => this._onReset()}>重置</WizButton>
        </WizCol>
      </WizRow>
    )
  }

  // imgStyle() {
  //   return {
  //     width: '100%',
  //     height: 150,
  //     backgroundImage: 'url(' + this.initialValue.fileUri + ')',
  //     backgroundPosition: 'center 0',
  //     backgroundSize: 'cover',
  //     backgroundRepeat: 'no-repeat',
  //   }
  // }
    _render() {
      const { getStudentPathList,trainPathStageLoading } = this.props;
      let {getPathInfo} = this.state
      let state
      getPathInfo && getPathInfo.length && getPathInfo.forEach(e => {
        state = e.state=='草稿' ? 1 : e.state == '已发布' ? 2 : e.state == '已关闭' ? 3 : 4
        this.initialValue.state = state
      })
      // let imgBackStyle = this.imgStyle();
      let dataItems = getPageData(getStudentPathList.data);
      let other = {};
      let columns = createColumns(this, dataItems, other);
      let searchBarProps = {
        columns,
        onSearch: values =>
          this.setState({ apiParams: values }, () => {
            this.getStudentPathList();
          })
      };
      let dataTableProps = {
        columns,
        rowKey: "personId",
        dataItems,
        showNum: false,
        isScroll: true,
        onChange: ({pageNum, pageSize}) => {
          this.getStudentPathList({current: pageNum, size: pageSize});
        }
      }

      let showUserPersonInfoVisible = this.state.showUserPersonInfoVisible;
      let personId = this.state.personId;
      let lookUserPersonInfoModal = {
        title: '查看已选任职',
        visible: showUserPersonInfoVisible,
        personId: personId,
        onCancel: (e) => {
          this.setState({
            showUserPersonInfoVisible: false,
            personId: '',
          });
        },
      };
      return (
        <>
            <WizSpin tip={'加载中'} spinning={trainPathStageLoading}>
              <TrainPathInfo { ...this.initialValue } />
              <WizCard>
                <WizTabs animated={false} >
                  <WizTabs.TabPane tab="路径阶段" key={0}>
                    <WizCollapse className='administrationScope-collapse'
                                 expandIconPosition='right'
                                 defaultActiveKey={[
                                   0
                                 ]}
                    >
                      {this.getPathList()}
                    </WizCollapse>
                  </WizTabs.TabPane>

                  <WizTabs.TabPane tab="路径学习记录" key={1}>
                    <WizSearchBar
                      className='searchbar-interval'
                      type="grid"
                      {...searchBarProps}
                    />
                    <WizDataTable {...dataTableProps} />
                    <div className="pagination">
                      <WizDataTable.Pagination {...dataTableProps} />
                    </div>

                  </WizTabs.TabPane>
                </WizTabs>
              </WizCard>
            </WizSpin>

          <WizModalUserIdentityShow {...lookUserPersonInfoModal}/>

          <WizModal key={2} title={this.state.modelName} visible={this.state.visible} onOk={this.handleOk.bind(this)} onCancel={this.handleCancel.bind(this)} width={800}>
            <WizCollapse className='administrationScope-collapse' expandIconPosition='right' defaultActiveKey={[0]}>
              {this.getStudentPathInfo()}
            </WizCollapse>
          </WizModal>


      </>
        );
    }

}


const mapStateToProps = (state, ownProps) => {
  const {trainPathStage} = state;
  const getPathInfo = modelUtils.getModelEntity(trainPathStage, "getPathInfo");
  const getStudentPathList = modelUtils.getModelEntity(trainPathStage, "getStudentPathList");
  const getStudentPathInfo = modelUtils.getModelEntity(trainPathStage, "getStudentPathInfo");
  const load = modelUtils.getLoadingState(state, ['trainPathStage']);

    return {
      getPathInfo,
      getStudentPathList,
      getStudentPathInfo,
        ...load
    };
};

export default connect(mapStateToProps)(LookTrainPath);
